export default __webpack_public_path__ + "static/media/3.8882c68e.svg";